var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.6,
    height: 22,
    viewBox: "0 0 17.6 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MdiFileQuestionOutline",
    d: "M15,2H6.2A2.2,2.2,0,0,0,4,4.2V21.8A2.192,2.192,0,0,0,6.2,24H19.4a2.192,2.192,0,0,0,2.2-2.2V8.6L15,2m4.4,19.8H6.2V4.2h7.7V9.7h5.5V21.8m-3.3-7.7c0,2.079-2.475,2.277-2.475,4.136h-1.65c0-2.684,2.475-2.486,2.475-4.136a1.65,1.65,0,0,0-3.3,0H9.5a3.3,3.3,0,1,1,6.6,0m-2.475,4.95V20.7h-1.65V19.05Z",
    transform: "translate(-4 -2)",
    fill: "#c52b30"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsIcon);
export default __webpack_public_path__ + "static/media/QuestionsIcon.ee9e46110197a375f1ead7cc532b150a.svg";
export { ForwardRef as ReactComponent };